import images from "./images";
import { FaRecycle, FaDroplet } from "react-icons/fa6";

const About = {
  sub: "know about us",
  heading: "Better water, better life, delivered.",
  description: [
    "Pure hydration made easy for homes and businesses. Our water solutions deliver clean, safe, and reliable drinking water every day. Experience better taste, fewer impurities, and convenient service right to your door with Aquadrop."
  ],
  experience: {
    year: "35",
    text: "years of experience",
  },
  points: [
    {
      id: 1,
      icon: <FaRecycle />,
      title: "eco-friendly",
      content: "We promote sustainability through reusable bottles and responsible water sourcing methods.",
    },
    {
      id: 2,
      icon: <FaDroplet />,
      title: "filtration plant",
      content: "Our advanced filtration plants remove impurities to provide fresh, safe drinking water.",
    },
  ],
  image: {
    src1: images.about1,
    src2: images.about2,
    alt1: "About-Image1",
    alt2: "About-Image2",
  },
  button: {
    text: "contact us",
    link: "Contact-us",
  },
};

export default About;